module.exports = __webpack_public_path__ + "static/media/mailsend.e7c4bfff.png";